var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('b-container',{attrs:{"fluid":""}},[_c('create-job-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }